import {isEmpty} from 'lodash-es';
import React from 'react';

import {Header, SpinningLoader} from '@/components';
import UserSecurityNotes from '@/components/SecurityNotes/UserSecurityNotes';

import MerchantUserProfile from './MerchantUserProfile';
import useMerchantUserDetails from './useMerchantUserDetails';

const MerchantUserDetails: React.FC = () => {
  const {
    user,
    loading,
    securityNotes,
    isLoadingSecurityNotes,
    hasMoreNotes,
    loadMoreSecurityNotes,
    isFetchingMore,
  } = useMerchantUserDetails();

  if (loading || isEmpty(user)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <SpinningLoader />
      </div>
    );
  }

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        dataCy="merchant-business-user-details-title"
        title="Business User Details"
      />
      {/* Merchant User Profile */}
      <MerchantUserProfile user={user} />
      {/* Security Notes */}
      <div className="px-3 pt-3 mt-8">
        <h3 className="font-semibold text-gray-900 dark:text-gray-300 mb-2">
          {'Security'.toLocaleUpperCase()}
        </h3>
        <hr className="mb-5 dark:border-dark-borderMid" />
        <UserSecurityNotes
          securityNotes={securityNotes}
          isLoadingSecurityNotes={isLoadingSecurityNotes}
          hasMoreNotes={hasMoreNotes}
          loadMoreSecurityNotes={loadMoreSecurityNotes}
          isFetchingMore={isFetchingMore}
        />
      </div>
    </main>
  );
};

export default MerchantUserDetails;
